import { gql } from '@apollo/client/core';

export const createBillingContact = gql`
  mutation createContact($data: BillingAccountContactCreateInput!) {
    createBillingAccountContact(data: $data) {
      id
      email
      receiveInvoices
    }
  }
`;
